import React from 'react';
import { Container } from 'semantic-ui-react';
import { toSnakeCase } from '../helpers/common';

const ArticleIntro = (props) => {
  const { anchorTagLinkText, date, text } = props;

  return (
    <section className={`article-intro ${date ? "article-intro__has-date" : ""}`} id={anchorTagLinkText && `${toSnakeCase(anchorTagLinkText)}`}>
      <Container>
        <div className="grid-wrapper">
          <div className={'article-intro__container'}>
            {text && <p dangerouslySetInnerHTML={{ __html: text }} className="article-intro__heading" />}

            {date && <p className="article-intro__date">{date}</p>}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default ArticleIntro;
